import { SharedEventTypeItem } from 'presentations/api/schema/event_type';
import { EventTypeUserListItem } from 'presentations/api/schema/event_type_user';
import EventSummary from 'presentations/views/components/organisms/EventSummary';
import EventHostSummary from 'presentations/views/components/organisms/EventHostSummary';
import { SharedEventDetailItem } from 'presentations/api/schema/event';

type Props = {
  event: SharedEventDetailItem | null;
  coverImage: string | null;
  eventType: SharedEventTypeItem;
  host: EventTypeUserListItem;
  hostImage: string | null;
  teamName: string | null;
  teamImage: string | null;
  eventTypeUsers: EventTypeUserListItem[];
};

export default function Component(props: Props) {
  if (props.event) {
    return <EventSummary event={props.event} />;
  }

  return (
    <EventHostSummary
      coverImage={props.eventType.coverImage}
      eventType={props.eventType}
      host={props.host}
      hostImage={props.hostImage}
      teamName={props.teamName}
      teamImage={props.teamImage}
      eventTypeUsers={props.eventTypeUsers}
    />
  );
}
